<script setup lang="ts">
import { CircleUser, Menu, User, XIcon } from 'lucide-vue-next'

import { ref } from 'vue'

const isOpen = ref(false)

const navigation = [

  { name: 'Мы', href: '/manifest/', icon: '' },
  { name: 'О сервисе', href: '#whyclients', icon: '' },
  { name: 'Как получить', href: '#zaemsteps' },
  { name: 'Как оплатить', href: '#howpay' },
  { name: 'Вопросы и ответы', href: '#faq' },
  { name: 'Документы ООО МКК «Небус»', href: '/documents/' },
  { name: 'Документы ООО МКК «Луна»', href: '/documents_luna/' },
  { name: 'Пройти опрос', href: '/survey/' },

]

const isDesktop = useMediaQuery('(min-width: 768px)')

const mainStore = useMainStore()
function openFeedbackModal() {
  mainStore.feedbackOpen = true
}

const { handleItemClick } = useHandleMenuClick(isOpen)
</script>

<template>
  <DropdownMenu v-model:open="isOpen">
    <DropdownMenuTrigger aria-label="Открыть меню">
      <Menu v-if="!isOpen" class="w-6 h-6" /> <XIcon v-else class="w-6 h-6" />
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="start"
      :side="isDesktop ? 'bottom' : 'top'"
      class="mt-4 w-[calc(100vw-2rem)] sm:w-full rounded-lg py-6 px-6"
      :class="{
        relative: isDesktop,
      }"
    >
      <FlipCard class="mb-4 mt-2 w-full md:hidden mx-auto" />
      <div v-if="!isDesktop" class="border-y border-gray-200 mb-2 mt-4 md:hidden">
        <DropdownMenuItem as-child class="md:hidden font-semibold hover:cursor-pointer text-lg w-full flex justify-between py-3 rounded-none" @click="navigateTo('https://login.nebusfinance.ru', { external: true })">
          <button class="text-lg w-full flex">
            Личный кабинет
            <User class="size-7 inline-block p-1 rounded-full bg-slate-200 font-semibold" />
          </button>
        </DropdownMenuItem>
      </div>
      <DropdownMenuItem v-for="item in navigation" :key="item.name" as-child class="hover:cursor-pointer text-lg w-full" @click="handleItemClick($event, item.href)">
        <button class="text-lg w-full">
          {{ item.name }}
        </button>
      </DropdownMenuItem>

      <DropdownMenuItem as-child class=" hover:cursor-pointer text-lg w-full" @click="openFeedbackModal">
        <button class="text-lg w-full">
          Оставить отзыв
        </button>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<style>
@media (max-width: 767px) {
  .dropdown-menu-content {
    animation: slideIn 0.3s ease-out;
  }

  @keyframes slideIn {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
}
</style>
